<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-bus`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40 4a4 4 0 014 4v26a4 4 0 01-4 4v3a3 3 0 01-3 3h-6a3 3 0 01-3-3v-3h-8v3a3 3 0 01-3 3h-6a3 3 0 01-3-3v-3a4 4 0 01-4-4V8a4 4 0 014-4h32zM16 38h-4v2h4v-2zm16 0h4v2h-4v-2zm8-14H8v3h9v4H8v3h32v-3h-9v-4h9v-3zM8 8h32v12H8V8z"/></svg>
</template>
<script>

export default {
  name: 'IconBus',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
